module.exports = __webpack_public_path__ + "img/Saved-Amex.64fcf78.svg";